import React, { useState } from "react";
import { Card, Button, Modal, Row } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "styled-components";
import { faPenToSquare, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

import ImportarProdutos from "./ImportarProdutos";
import FormularioDeProdutos from "./FormularioDeProdutos";
import ExportarProdutos from "./ExportarProdutos";
import GerenciarProdutos from "./GerenciarProdutos";
import GerenciarCategorias from "./GerenciarCategorias";
import { useConfigQuery } from "../../../../queries/useConfig";
import CadastroFiscal from "./CadastroFiscal";

const Produtos = () => {
    const { data: config, error } = useConfigQuery();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const accessToken = window.localStorage.getItem("accessToken");
    const [podeAbandonar, setPodeAbandonar] = useState(true);
    const [msgSairTela, setMsgSairTela] = useState('');

    const bloquearAcesso = (palavra) => {
        if (!palavra) return false;
        if (config.bloqueiosDoUsuario.toLowerCase().includes(String(palavra).toLowerCase())) {
            return true;
        } else {
            return false;
        }

    };

    const handleOpenModal = (component) => {
        setModalContent(component);
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setModalContent(null);
    };

    const handleExitClick = () => {
        if (podeAbandonar) {
            const confirmExit = window.confirm(`${msgSairTela}`);
            if (confirmExit) {
                handleCloseModal();
            }
        }
    };

    const abrirCadastroDeProdutos = () => {
        window.open(`https://technotafiscal.technfe.com.br?tokenUrl=${accessToken}`, "_blank");
    };
    return (
        <Container>
            <Card style={{ width: "85%", textAlign: "center", backgroundColor: "transparent" }}>
                <Row gutter={[16, 16]} justify="center">
                    <ButtonStyled disabled={bloquearAcesso('op.cadp.antigo')} onClick={abrirCadastroDeProdutos} style={{ backgroundColor: '#d64d4d', width: '150px', height: '150px' }}>
                        <FontAwesomeIcon icon={faPenToSquare} size="2x" />
                        <ButtonText>Gerenciar Produtos (Antigo)</ButtonText>
                    </ButtonStyled>

                    <ButtonStyled disabled={bloquearAcesso('op.cadp.exportar')} onClick={() => { setMsgSairTela('Deseja abandonar a entrada de produtos?'); handleOpenModal(<ExportarProdutos />) }} style={{ backgroundColor: '#4682B4', width: '150px', height: '150px' }}>
                        <FontAwesomeIcon icon={faPenToSquare} size="2x" />
                        <ButtonText>Exportar Produtos</ButtonText>
                    </ButtonStyled>

                    <ButtonStyled disabled={bloquearAcesso('op.cadp.importar')} onClick={() => { setMsgSairTela('Deseja abandonar a entrada de produtos?'); handleOpenModal(<ImportarProdutos />) }} style={{ backgroundColor: '#FFA500', width: '150px', height: '150px' }}>
                        <FontAwesomeIcon icon={faPenToSquare} size="2x" />
                        <ButtonText>Importar Produtos</ButtonText>
                    </ButtonStyled>

                    <ButtonStyled disabled={bloquearAcesso('op.cadp.novo')} onClick={() => { setMsgSairTela('Deseja abandonar a entrada de produtos?'); handleOpenModal(<GerenciarProdutos />) }} style={{ backgroundColor: '#c5480dff', width: '150px', height: '150px' }}>
                        <FontAwesomeIcon icon={faPenToSquare} size="2x" />
                        <ButtonText>Gerenciar Produtos (Novo)</ButtonText>
                    </ButtonStyled>

                    <ButtonStyled disabled={bloquearAcesso('op.cadp.gerenciarcategorias')} onClick={() => { setMsgSairTela('Deseja abandonar a entrada de categorias?'); handleOpenModal(<GerenciarCategorias />) }} style={{ backgroundColor: '#0dc554ff', width: '150px', height: '150px' }}>
                        <FontAwesomeIcon icon={faPenToSquare} size="2x" />
                        <ButtonText>Gerenciar Categorias</ButtonText>
                    </ButtonStyled>

                    <ButtonStyled disabled={bloquearAcesso('op.cadp.cadastrofiscal')} onClick={() => { setMsgSairTela('Deseja abandonar o cadastro fiscal?'); handleOpenModal(<CadastroFiscal />) }} style={{ backgroundColor: 'rgb(130, 11, 209)', width: '150px', height: '150px' }}>
                        <FontAwesomeIcon icon={faPenToSquare} size="2x" />
                        <ButtonText>Cadastro Fiscal</ButtonText>
                    </ButtonStyled>
                </Row>
            </Card>

            <Modal
                visible={isModalVisible}
                onCancel={handleExitClick}
                footer={null}
                width="100vw"
                bodyStyle={{ padding: 0 }}
                centered
                closeIcon={null} // Remove o ícone de fechamento padrão
                destroyOnClose={true}
            >
                <ModalHeader>

                    <Button
                        type="primary"
                        disabled={!podeAbandonar}
                        onClick={handleExitClick}
                        style={{ backgroundColor: "black", borderColor: "black", color: '#fff' }}
                    >
                        <span>Abandonar <FontAwesomeIcon icon={faSignOutAlt} /></span>
                    </Button>
                </ModalHeader>
                <ModalBody>{modalContent}</ModalBody>
            </Modal>
        </Container>
    );
};



const ButtonStyled = styled(Button)`
  width: 150px;
  height: 150px;
  border: none;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  margin: 10px;
  text-align: center;
  padding: 10px;
  overflow: hidden; /* Esconde qualquer conteúdo que ultrapasse o limite do botão */
  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

const ButtonText = styled.span`
  margin-top: 10px;
  font-weight: bold;
  text-align: center;
  word-wrap: break-word; /* Quebra o texto para a próxima linha, se necessário */
  width: 100%;
  white-space: normal; /* Permite quebra de linha */
  overflow-wrap: break-word; /* Garante a quebra de palavra se for muito longa */
  display: block;
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  height: 100vh;
  position: relative;
`;


const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 16px;
  background: #fff;
`;

const ModalBody = styled.div`
  padding: 0;
  margin:0;
  height: calc(100vh - 19vh); // Ajusta a altura do corpo do modal
`;


export default Produtos;
